import { Container, DialogActions, DialogTitle, Grid } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import Chip from "../../../components/basics/Chip";
import SelectErp from "../../../components/basics/SelectErp";
import Btn from "../../../components/buttons/Btn";
import Card from "../../../components/cards/Card";
import { TemplateEmailsContext } from "../contexts/TemplateEmailsContext";
import useTemplatesEmailsController from "../controller/TemplatesEmailsController";
import {
  Header,
  Body,
  CustomDialog,
  DialogContentStyled,
  StyledDialog,
} from "../styles/Modals";
import { DivHeandleEmail } from "../styles/ContentForm";
import TextField from "../../../components/basics/TextFieldErp";
import EditorTiny from "../../../components/inputs/EditorTiny";
import { QueryParamsContext } from "../../../context/QueryParamsContext";

const ModalFooters = ({ open, setContent, setOpen }) => {
  const {
    footer,
    setFooter,
    footersList,
    setFootersList,
    footerEditor,
    setFooterEditor,
    descriptionFooter,
    setDescriptionFooter,
    setFooterHeandle,
  } = useContext(TemplateEmailsContext);

  const { queryParams } = useContext(QueryParamsContext);

  const [disabledEditor, setDisabledEditor] = useState(true);

  const { initHeandleInputs, store, show, update, destroy, selectedItem } =
    useTemplatesEmailsController();

  useEffect(() => {
    if (queryParams.empresa_cnpj) initHeandleInputs("footer");
  }, [initHeandleInputs, queryParams.empresa_cnpj]);

  useEffect(() => {
    setDescriptionFooter("");
    if (footer?.value === "") {
      setDisabledEditor(false);
      setFooterEditor("");
    } else {
      setDisabledEditor(true);
    }

    if (footer?.value) {
      show("footers");
    }
  }, [footer, show, setFooterEditor, setDescriptionFooter]);

  const handleClose = () => {
    setContent(null);
    setOpen(false);
  };

  const clearStates = () => {
    setFooter("");
    setFooterEditor("");
    setFootersList(null);
    setDescriptionFooter("");
    setDisabledEditor(true);
  };

  const handleSave = async () => {
    if (footer?.value === "") {
      await store("footers");
    } else {
      await update("footers");
      selectedItem("footer");
    }
    clearStates();
    handleClose();
  };

  const handleDestroy = async () => {
    await destroy("footers");
    setFooterHeandle("");
    clearStates();
    initHeandleInputs("footer");
  };

  return (
    <CustomDialog
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      fullWidth={true}
      disableEnforceFocus={true}
    >
      <StyledDialog>
        <DialogTitle id="dialog-title">
          <Header>
            <Grid container align="center" justifyContent="center">
              <Chip
                bgcolor="primary"
                textcolor="white"
                label={"CONFIGURAÇÃO DE RODAPÉ"}
              />
            </Grid>
          </Header>
        </DialogTitle>
        <DialogContentStyled>
          <Body>
            <Container maxWidth="lg">
              <Card fullWidth={true} line="left">
                <Grid item container xs={12} spacing={1}>
                  <Grid item xs>
                    <SelectErp
                      error={false}
                      loading={false}
                      label="Rodapé"
                      value={footer}
                      setValue={setFooter}
                      optionsList={footersList}
                      descriptionField="label"
                      variant="filled"
                    />
                  </Grid>
                  <Grid item xs>
                    {(footer?.value === "" || !disabledEditor) && (
                      <TextField
                        label="Descrição"
                        variant="filled"
                        type="text"
                        size="small"
                        setValue={setDescriptionFooter}
                        value={descriptionFooter}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item container xs={12} spacing={1}>
                  {(footer?.value || footer?.value === "") && (
                    <DivHeandleEmail>
                      <EditorTiny
                        value={footerEditor}
                        setValue={setFooterEditor}
                        disabled={disabledEditor}
                      />
                    </DivHeandleEmail>
                  )}
                </Grid>
              </Card>
            </Container>
          </Body>
        </DialogContentStyled>
        <DialogActions>
          <Grid item container xs spacing={1}>
            <Grid item container xs />
            {footer?.value && disabledEditor && (
              <Grid item container xs={2}>
                <Btn
                  onClick={() => {
                    selectedItem("footer");
                    clearStates();
                    handleClose();
                  }}
                  bgcolor="darkgreen"
                  label="Selecionar"
                  hovercolor="blue"
                  fullWidth={true}
                />
              </Grid>
            )}
            {footer?.value && footer?.access === "private" && disabledEditor && (
              <Grid item container xs={1}>
                <Btn
                  onClick={() => setDisabledEditor(false)}
                  bgcolor="orange"
                  label="Editar"
                  hovercolor="blue"
                />
              </Grid>
            )}
            {(footer?.value || footer?.value === "") &&
              descriptionFooter &&
              !disabledEditor &&
              footerEditor && (
                <Grid item container xs={3}>
                  <Btn
                    onClick={handleSave}
                    bgcolor="darkgreen"
                    label="Salvar e Selecionar"
                    hovercolor="blue"
                    fullWidth={true}
                  />
                </Grid>
              )}
            {(footer?.value || footer?.value !== "") &&
              footer?.access === "private" &&
              !disabledEditor && (
                <Grid item container xs={1}>
                  <Btn
                    onClick={handleDestroy}
                    bgcolor="darkred"
                    label="Excluir"
                    hovercolor="blue"
                  />
                </Grid>
              )}
            <Grid item container xs={1}>
              <Btn
                onClick={handleClose}
                bgcolor="grey"
                label="Cancelar"
                hovercolor="blue"
              />
            </Grid>
          </Grid>
        </DialogActions>
      </StyledDialog>
    </CustomDialog>
  );
};

export default ModalFooters;
